// Smart phone normalisation for Indian numbers.
// Customer types just "9876543210" and we send "+919876543210" to the backend.
// Already-prefixed numbers and emails are left alone.

export function normalizePhoneOrEmail(input) {
  const trimmed = (input || "").trim();
  if (!trimmed) return "";
  if (trimmed.includes("@")) return trimmed.toLowerCase();
  const digits = trimmed.replace(/\D/g, "");
  if (!digits) return trimmed;
  if (trimmed.startsWith("+")) return "+" + digits;
  if (digits.length === 10) return "+91" + digits;
  if (digits.length === 11 && digits.startsWith("0")) return "+91" + digits.slice(1);
  if (digits.length === 12 && digits.startsWith("91")) return "+" + digits;
  if (digits.length >= 10) return "+" + digits;
  return trimmed; // too short — let backend handle the error
}

/** Normalises a 10-digit phone-only field (used in registration where we already show "+91" as a prefix). */
export function normalizeIndianPhone(tenDigits) {
  const digits = (tenDigits || "").replace(/\D/g, "").slice(0, 10);
  return digits.length === 10 ? "+91" + digits : "";
}
